import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { InviewAnim } from "../utils/viewport-anim";

export const ServiceUnitCard = ({ cardData }) => {
    const { caption, text1, text2 } = cardData;

    return (
        <InviewAnim>
            <div className="service-unit">
                <div className="service-unit-title flx-rw c-jt">{caption}</div>
                <div className="service-unit-text flx-rw">
                    <FontAwesomeIcon icon={faCheckCircle} className="tick" />
                    <span className="serv-txt">
                        {text1}
                    </span>
                </div>
                <div className="service-unit-text flx-rw">
                    <FontAwesomeIcon icon={faCheckCircle} className="tick" />
                    <span className="serv-txt">
                        {text2}
                    </span>
                </div>
            </div>
        </InviewAnim>
    )
}